export interface Municipality {
  georesMunicipalityId: number
  name: string
}

export interface CmhInformation {
  proximusAvailable: boolean,
  vooAvailable: boolean,
  swdeAvailable: boolean,
  resaGazAvailable: boolean
}

export enum GridOperator {
  ores = "ORES",
  resa = "RESA SA"
}

export enum ManagerName {
  ores = "ORES Assets",
  resa = "RESA SA"
}

export interface GridOperators {
  operators: GridOperator[]
  isInOresScope: boolean
}

export interface Manager {
  name: ManagerName
  isOres: boolean
}

export interface GridManagers {
  electricityManager: Manager | null
  gasManager: Manager | null
}

export interface Office {
  name: string
}

export interface OperationalOffices {
  electricityOffice: Office | null
  gasOffice: Office | null
}

export interface SubCity {
  georesSubcityId: number
  zipCode: string
  cityName: string
  municipality: Municipality
  isFictive: boolean
  connectMyHomeActivated: boolean
  connectMyHomeActivationDate: Date | null
  connectMyHomeInformation: CmhInformation | null
  gridOperators: GridOperators | null
  gridManagers: GridManagers
  operationalOffices: OperationalOffices
}

export interface SubCityStreet {
  georesStreetSubcityId: number | null,
  georesStreetId: number | null,
  name: string
}

export interface SubCityStreetAddress {
  georesAddressId: number
  houseNumber: string
}
